import produce from 'immer';

import * as helpers from '../helpers';
import { JACKPOTS_CASINO_FETCH, JACKPOTS_BINGO_FETCH } from './actions';

export const defaultState = {
    jackpotStartTime: null,
    jackpots: {}
};

export const reducer = produce((draftState, action) => {
    switch (action.type) {
        case JACKPOTS_CASINO_FETCH: {
            const jackpots = action.payload?.casinoJackpots || {};

            draftState.jackpots = {
                ...draftState.jackpots,
                ...jackpots
            };

            draftState.jackpotStartTime = Date.now();

            break;
        }

        case JACKPOTS_BINGO_FETCH: {
            const { jackpots: vfJackpots = [] } = action.payload?.vfJackpots || {};
            const jackpots = helpers.parseVFJackpots(vfJackpots);

            draftState.jackpots = {
                ...draftState.jackpots,
                ...jackpots
            };

            draftState.jackpotStartTime = Date.now();

            break;
        }

        default:
            break;
    }
}, defaultState);
